import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SvgLoaderService {
    private readonly http = inject(HttpClient);
    private readonly cache = new Map<string, Observable<string>>();

    load(path: string): Observable<string> {
        const cached = this.cache.get(path);
        if (cached) {
            return cached;
        }

        const stream = this.http.get(path, { responseType: 'text' }).pipe(
            map((raw) => this.transform(raw)),
            catchError(() => of('')),
            shareReplay({ bufferSize: 1, refCount: false }),
        );

        this.cache.set(path, stream);
        return stream;
    }

    private transform(svg: string): string {
        let result = svg
            .replace(/\swidth="[^"]*"/i, '')
            .replace(/\sheight="[^"]*"/i, '')
            .replace(/fill="(?!none|currentColor)[^"]*"/gi, 'fill="currentColor"')
            .replace(/stroke="(?!none|currentColor)[^"]*"/gi, 'stroke="currentColor"');

        result = result.replace(/style="([^"]*)"/gi, (_match, body: string) => {
            const cleaned = body
                .replace(/fill\s*:\s*(?!none|currentColor)[^;]+/gi, 'fill: currentColor')
                .replace(/stroke\s*:\s*(?!none|currentColor)[^;]+/gi, 'stroke: currentColor');
            return `style="${cleaned}"`;
        });

        if (/<svg\b[^>]*\sfill\s*=/i.test(result)) {
            result = result.replace(/(<svg\b[^>]*\s)fill\s*=\s*"[^"]*"/i, '$1fill="currentColor"');
        } else {
            result = result.replace(/<svg\b/i, '<svg fill="currentColor"');
        }

        return result;
    }
}
